const ATTR_VIDEO = 'data-klt-c-video';

export default function init(vendorRoot: string) {
    try {
        vendorRoot = vendorRoot || '';

        const videoElements = document.querySelectorAll(`[${ATTR_VIDEO}]`);

        if (videoElements && videoElements.length > 0) {
            // Ensure video.js does not include any telemetrie tracking
            // @ts-ignore
            window.HELP_IMPROVE_VIDEOJS = false;

            // Async load the video-js css files once for all the videos
            // asyncLoadCSS('video-js.min.css', vendorRoot);
            import(`video.js`).then((videojsModule) => {
                for (var i = 0; i < videoElements.length; i++) {
                    const videojs = videojsModule.default;

                    // Tempoarily make the parent container having the size of the video
                    // This is used to avoid a visible glitch as videojs first remove the video element before adding a custom div element
                    const videoId = videoElements[i].id;
                    const nativeVideo = document.getElementById(videoId);
                    nativeVideo.parentElement.style['height'] = nativeVideo.offsetHeight + 'px';

                    // Hook on player readiness
                    // Refs: https://docs.videojs.com/tutorial-setup.html#player-readiness
                    videojs(videoElements[i].id, null, function (e) {
                        const customVideo = document.getElementById(videoId);
                        // Add programatically the videojs styling classes to avoid visual glitches happening before the video is loaded
                        customVideo.classList.add('klt-c-video--videojs-loaded');
                        customVideo.classList.add('vjs-fluid', 'vjs-big-play-centered');
                        customVideo.classList.add('vjs-big-play-centered');
                        // Remove temporary height styling on the parent container as the custom div element of videojs is now added
                        customVideo.parentElement.removeAttribute('style');
                    });
                }
            });
        }
    } catch (e) {
        console.error(`Couldn't initialize video module.`, e);
    }
}

function asyncLoadCSS(cssFileName: string, vendorRoot: string) {
    // Docs: https://www.filamentgroup.com/lab/async-css.html
    // make a stylesheet link
    const cssLink = `${vendorRoot.replace('js', 'css')}/${cssFileName}`;
    if (!isCSSLinkLoaded(cssLink)) {
        let asyncLoadedCSS = document.createElement('link');
        asyncLoadedCSS.rel = 'stylesheet';
        asyncLoadedCSS.href = cssLink;
        // insert it at the end of the head in a legacy-friendly manner
        document.head.insertBefore(
            asyncLoadedCSS,
            document.head.childNodes[document.head.childNodes.length - 1].nextSibling
        );
    }
}

function isCSSLinkLoaded(link) {
    return !!document.head.querySelector(`link[href*="${link}"]`);
}
